"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawerContentContainer = exports.DrawerHeaderContainer = exports.Overlay = exports.DrawerSlide = exports.overlayHidden = exports.overlayVisible = exports.collapse = exports.expand = void 0;
const Theme_1 = require("../../Theme/Theme");
exports.expand = (0, Theme_1.keyframes) `
  from {
    transform: translateX(100%);
  }
    to {
    transform: translateX(0);
  }
`;
exports.collapse = (0, Theme_1.keyframes) `
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(100%);
  }
`;
exports.overlayVisible = (0, Theme_1.keyframes) `
  from {
    opacity: 0;
    visibility: hidden;
  }
  to {
    opacity: 1;
    visibility: visible;
  }
`;
exports.overlayHidden = (0, Theme_1.keyframes) `
  from {
    opacity: 1;
    visibility: visible;
  }
  to {
    opacity: 0;
    visibility: hidden;
  }
`;
exports.DrawerSlide = Theme_1.styled.div `
  position: fixed;
  top: 0;
  right: 0;
  width: ${(props) => (props.width ? `${props.width}px` : '900px')};
  background-color: #fff;
  height: 100vh;
  ${(props) => props.open ? 'box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.5)' : null};
  animation: ${(props) => (props.open ? exports.expand : exports.collapse)} 250ms ease;
  transform: ${(props) => (props.open ? 'translateX(0)' : 'translateX(100%)')};
  transition: transform 250ms ease;
  display: ${(props) => (props.isClosing ? 'block' : 'none')};
  z-index: ${(props) => (props.drawerZIndex ? props.drawerZIndex : 1000)};
`;
exports.Overlay = Theme_1.styled.div `
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${(props) => props.overlayVisible ? 'rgba(0, 0, 0, 0.5)' : 'transparent'};
  animation: ${(props) => (props.open ? exports.overlayVisible : exports.overlayHidden)} 250ms
    ease;
  opacity: ${(props) => (props.open ? '1' : '0')};
  visibility: ${(props) => (props.open ? 'visible' : 'hidden')};
  transition: opacity 250ms ease, visibility 250ms ease;
  display: ${(props) => (props.isClosing ? 'block' : 'none')};
  z-index: ${(props) => (props.overlayZIndex ? props.overlayZIndex : 999)};
`;
exports.DrawerHeaderContainer = Theme_1.styled.div `
  height: ${(props) => (props.height ? `${props.height}px` : '60px')};
  ${(props) => (props.open ? props.headerSeparatorType : null)};
`;
exports.DrawerContentContainer = Theme_1.styled.div `
  height: ${(props) => props.height ? `${props.height}px` : 'calc(100% - 88px)'};
  overflow-y: auto;
`;
//# sourceMappingURL=Drawer.styles.js.map